var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
			'fill-height': _vm.fillContainer || _vm.fillHeight,
			'fill-width': _vm.fillContainer || _vm.fillWidth,
		}},[(_vm.isLoading)?_c('div',{staticClass:"d-flex text-center fill-height"},[_c('div',{staticClass:"ma-auto"},[_c('v-progress-circular',{attrs:{"indeterminate":"","width":"3"}}),_c('div',{staticClass:"mt-3"},[_vm._v(" "+_vm._s(_vm.$t("pages.common.loading"))+" ")])],1)]):[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }